import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import { Input } from "decorator-form";
import * as actionFragments from "./topicActions";
import * as metaFragments from "./topicMeta";

/**
 * Configuration fragment for this component.
 * Add this to the config of panels that use it.
 */

// const topicLayout = FragmentProvider.getLayoutInput({...metaFragments, ...actionFragments});
// const availableFragments = FragmentProvider.getInput({...metaFragments, ...actionFragments});

export default class TopicComponentConfig {

	@Input({type: InputType.CHECKBOX, title: "Minimal display"})
	public minimal: boolean;

	// Display a numerical count of child topics
	@Input({type: InputType.CHECKBOX, title: "Show meta icons"})
	public metaIcons: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Action icons"})
	public actionIcons: boolean = true;

	// Removed this for now because SubFormWidget not rendering it properly; passing in from parent
	// @Input({type: topicLayout, title: "Layout"})
	public topicLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: InputType.CHECKBOX, title: "HTML Enabled"})
	public htmlEnabled: boolean;

}

export const topicFormWidget = SubFormWidget.registerForm(TopicComponentConfig);



// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicComponentConfig.ts